"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const COMPOUND_PERIOD_SECONDS = 60;
const CONSTANTS = {
    COMPOUND_PERIOD_SECONDS,
    COMPOUNDS_PER_YEAR: (365 * 24 * 60 * 60) / COMPOUND_PERIOD_SECONDS,
    PRECISION: new bignumber_js_1.default(Math.pow(10, 18)),
};
exports.default = CONSTANTS;
//# sourceMappingURL=constants.js.map